// Todas as URLs do app num só lugar. As rotas antigas continuam funcionando
// via redirecionamento (ver LEGACY_REDIRECTS em routes/AppRoutes.tsx).
export const PATHS = {
  signIn: "/signin/",
  signUp: "/signup/",
  partners: "/parceiros/",
  forgotPassword: "/reset-password/",
  newPassword: "/change-password/",
  paymentSuccess: "/payment/checkout/success/",
  publicShowcase: "/vitrine/:slug",
  oauthGoogleLogin: "/oauth/google/login/callback",
  oauthGoogleAds: "/oauth/google/callback",
  oauthMeta: "/oauth/meta/callback",

  dash: "/dash/",
  hireAccount: "/dash/contratar-conta/",
  home: "/dash/inicio/",

  overview: "/dash/visao-geral/",
  linkGenerator: "/dash/gerador-de-link/",

  site: "/dash/analytics/seu-site/",
  googleAds: "/dash/analytics/google-ads/",
  metaAds: "/dash/analytics/meta-ads/",
  tags: "/dash/analytics/tags/",
  tagsBySource: (source: string) =>
    `/dash/analytics/tags/${encodeURIComponent(source)}/`,
  tagDetail: (source: string, tag: string) =>
    `/dash/analytics/tags/${encodeURIComponent(source)}/${encodeURIComponent(tag)}/`,
  funnelReports: "/dash/analytics/funil-de-vendas/relatorios/",
  funnelForms: "/dash/analytics/funil-de-vendas/formularios/",

  proAnalyses: "/dash/analytics-pro/analises/",
  proAnalysis: (id: string) => `/dash/analytics-pro/analises/${encodeURIComponent(id)}/`,
  proAi: "/dash/analytics-pro/ia/",

  showcaseHome: "/dash/social/",
  showcaseHeader: "/dash/social/cabecalho/",
  showcaseEditor: "/dash/social/editor/",
  showcaseThemes: "/dash/social/temas/",
  showcaseReports: "/dash/social/relatorios/",

  trackingCode: "/dash/integracoes/codigo/",
  connectedAccounts: "/dash/integracoes/contas/",

  subscription: "/dash/minha-conta/assinatura/",
  plans: "/dash/minha-conta/planos/",
  accountData: "/dash/minha-conta/dados-cadastrais/",
  users: "/dash/minha-conta/usuarios/",
  profile: "/dash/minha-conta/perfil/",
} as const;

// Telas de entrada (PublicOnlyRoute): sem sessão obrigatória, mas quem já
// está logado é redirecionado para o painel — por isso ainda verificam a sessão.
const PUBLIC_ONLY_PREFIXES = ["/signin/", "/signup/", "/parceiros/", "/reset-password/", "/change-password/"];

// Demais rotas públicas: não dependem de sessão nem redirecionam quem já
// está logado (callback de OAuth, vitrine pública, confirmação de pagamento).
const PUBLIC_PREFIXES = [
  ...PUBLIC_ONLY_PREFIXES,
  "/payment/checkout/success/",
  "/oauth/",
  "/vitrine/",
];

// Aceita a URL com ou sem a barra final ("/parceiros" e "/parceiros/").
const withSlash = (pathname: string) => (pathname.endsWith("/") ? pathname : `${pathname}/`);

export const isPublicOnlyPath = (pathname: string): boolean =>
  PUBLIC_ONLY_PREFIXES.some((prefix) => withSlash(pathname).startsWith(prefix));

export const isPublicPath = (pathname: string): boolean =>
  PUBLIC_PREFIXES.some((prefix) => withSlash(pathname).startsWith(prefix));

// Contas integradas recebe `?conectado=google|meta` ao voltar da conexão
// (OAuthCallback) para avisar que deu certo.
export const OAUTH_CONNECTED_PARAM = "conectado";
